module.exports = __webpack_public_path__ + "static/img/4.e199692.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/4.png
// module id = CpJ4
// module chunks = 0